import { render, staticRenderFns } from "./NotYet.vue?vue&type=template&id=a672ed72&"
import script from "./NotYet.vue?vue&type=script&lang=js&"
export * from "./NotYet.vue?vue&type=script&lang=js&"
import style0 from "./NotYet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports